type Assessment = object;

export const emcSharedAssessmentAU: Assessment = {} as const;
